// extracted by mini-css-extract-plugin
module.exports = {"LowestPrice":"LowestPrice_LowestPrice__36hNV","LowestPrice__Emphasis":"LowestPrice_LowestPrice__Emphasis__34V7Y"};